import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect } from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { MdDelete } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import FormFileUpload from "../../components/formFields/FormFileUpload";
import {
  requiredArrayValidator,
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import { setBrochureAttachmentDeleteIndex } from "./brochureSlice";
import IconComponent from "../../components/common/IconComponent";
// import { GETALLACTIVEWITHFILTER_TYPE } from "../../_contstants/common";

const BrochureAttachementArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const BrochureAttachmentDeleteIndex = useAppSelector(
    (state) => state.brochure.BrochureAttachmentDeleteIndex
  );

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(setBrochureAttachmentDeleteIndex(-1));
      dispatch(closeDialog());
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps?.onPush({
      value: {
        Title: "",
      },
    });
  }, [fieldArrayRenderProps]);

  useEffect(() => {
    if (
      !fieldArrayRenderProps?.value ||
      (fieldArrayRenderProps?.value && fieldArrayRenderProps?.value?.length < 1)
    ) {
      pushElementInarray();
    }
  }, []);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openDialog(`delete${fieldArrayRenderProps?.name}Dialog`));
    dispatch(setBrochureAttachmentDeleteIndex(index));
  };

  return (
    <>
      {dialogName === `delete${fieldArrayRenderProps?.name}Dialog` && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Report"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() =>
                    handleDeleteAction(BrochureAttachmentDeleteIndex)
                  }
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      <table className="brochure-attachment-table">
        <tr>
          <th style={{ width: 500 }}>Attachment</th>
          <th>Title</th>
          <th style={{ width: 80 }}></th>
        </tr>
        {fieldArrayRenderProps.value &&
          fieldArrayRenderProps.value.length > 0 &&
          fieldArrayRenderProps.value.map((Reports: any, index: number) => (
            <tr>
              <td>
                <Field
                  wrapperClassName="m-0"
                  name={`${fieldArrayRenderProps.name}.${index}.Image`}
                  multiple={false}
                  type="file"
                  accept="image/*"
                  component={FormFileUpload}
                  validator={
                    fieldArrayRenderProps.formRenderProps.valueGetter(
                      `${fieldArrayRenderProps.name}.${index}.Title`
                    )
                      ? requiredArrayValidator
                      : skipValidator
                  }
                />
              </td>
              <td>
                <Field
                  wrapperClassName="m-0"
                  name={`${fieldArrayRenderProps.name}.${index}.Title`}
                  placeholder="Title"
                  component={FormTextField}
                  validator={
                    fieldArrayRenderProps.formRenderProps.valueGetter(
                      `${fieldArrayRenderProps.name}.${index}.Image`
                    )?.length > 0
                      ? requiredValidator
                      : skipValidator
                  }
                />
              </td>
              <td>
                {fieldArrayRenderProps.value.length - 1 === index ? (
                  <Button
                    style={{
                      height: 30,
                      width: 30,
                      marginLeft: 20,
                    }}
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={pushElementInarray}
                    type="button"
                  >
                    <IconComponent icon={FaPlus} style={{ fontSize: "16px" }} />
                  </Button>
                ) : (
                  <Button
                    style={{
                      height: 30,
                      width: 30,
                      marginLeft: 20,
                    }}
                    onClick={() => handleOpenDeleteDialog(index)}
                    fillMode={"solid"}
                    themeColor={"error"}
                    type="button"
                    size={"small"}
                  >
                    <IconComponent
                      icon={MdDelete}
                      style={{ fontSize: "20px" }}
                    />
                  </Button>
                )}
              </td>
            </tr>
          ))}
      </table>
    </>
  );
};

export default BrochureAttachementArray;
